import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SessionClientService {
  constructor(private http: HttpClient) {}

  public getSessionState(): Observable<null> {
    return this.http.get<null>('/sessions/active?v2');
  }
}
